module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/modules/_add-to-unscopables.js
// module id = 327
// module chunks = 0